import { Component, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import {CartService} from 'src/app/services/cart.service';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { DatePipe } from '@angular/common';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import {SettingsService} from '../../services/settings.service';
import { ActivatedRoute ,Router} from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { UserService } from 'src/app/services/user.service';
import { UserPrivilegeService } from 'src/app/services/user-privilege.service';
import { FlightService } from 'src/app/services/flight.service';
import { MatChipInputEvent } from '@angular/material/chips';
import { FormControl } from '@angular/forms';
import { Observable, map, startWith } from 'rxjs';
import {AirManagementService} from  '../../services/air-management.service'
import * as XLSX from "xlsx";
import * as ExcelJS from 'exceljs';
import { MatTabChangeEvent } from '@angular/material/tabs';



@Component({
  selector: 'app-manage-carts',
  templateUrl: './manage-carts.component.html',
  styleUrls: ['./manage-carts.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class ManageCartsComponent {
  columnsToDisplayWithExpand = ['expand','generationTime','firstDeparture','cartId','bookedBy','corporate_Agent','type','summary','approvalStatus','bookingStatus','paymentStatus'];

  expandedElement!: any | null;
  maxDate:any
constructor(private location: Location,private cartService:CartService,private dataService:DataService,private FlightService:FlightService,
  private SettingsService:SettingsService,private router:Router,private UserService:UserService,    private userPrivileges: UserPrivilegeService,
  private AirManagementService:AirManagementService)
{
  this.branchList()
  this.carrierCodelist()

  this.maxDate=new Date()
  this.AirList()
  this.userPrivileges.userPrivilegesByModule('Manage-Cart').then((privileges:any) => {
    this.privilegesValue(privileges)
  })
  .catch((error:any) => {
  console.error(error); // Handle errors, if any
  });
  this.UserList()
  this.filteredTo = this.ToCtrl.valueChanges.pipe(
    startWith(''),
    map((state:any) => (state ? this._filterStates(state) : this.whereTo.slice())),
  );
  this.filteredHotelTo = this.ToHotelCtrl.valueChanges.pipe(
    startWith(''),
    map((state:any) => (state ? this._filterStates(state) : this.whereTo.slice())),
  );
  this.filteredBookedBY = this.bookedBYCtrl.valueChanges.pipe(
    startWith(''),
    map((state:any) => (state ? this._filterBooked(state) : this.bookedByList.slice())),
  );

}
private _filterStates(value: string): any[] {
  const filterValue = value.toLowerCase();

  return this.whereTo.filter((state:any) => state.name.toLowerCase().includes(filterValue));
}
private _filterBooked(value: string): any[] {
  const filterValue = value.toLowerCase();

  return this.bookedByList.filter((state:any) => state.name.toLowerCase().includes(filterValue));
}
moreFilters:boolean=false
emulateEmail:any

userlist:any=[]
  UserList(){
  
    // this.userType=this.userType.toUpperCase()
      this.UserService.getUserList('')
      .subscribe({
        next : (res:any) => {
          if(res) {
           // console.log(res)
          let  data:any;
          data=res["result"]
          this.userlist=data
          this.whereTo=data
          this.bookedByList=data
          // for (let i = 0; i < data.length; i++) {
            
          //   this.whereTo.push(data[i]?.name);

          // }
   
        }else{

        }},error : (err) => {
    
          console.error("Error in fetching data");
        }
      }
    )
    
  }
onClickFilters(){
this.moreFilters=!this.moreFilters
}
date10min(item:any)
{
  const originalDate = new Date(item);
  
  const newDate = new Date(originalDate.setDate(originalDate.getDate() - 7));
  newDate.setHours(0, 0, 0, 0);
  return newDate
} 
myControl = new FormControl('');
changeCarrier(){
this.pera.airline=this.myControl.value?.split(',')[1]
this.AirList()

 
}

filteredOptions!: Observable<any>;
carrierCodeList:any=[]
ngOnInit() {
  
  this.filteredOptions = this.myControl.valueChanges.pipe(
    startWith(''),
    map((value:any) => this._filter(value || '')),
  );
}


pera:any={
  invoiceStatus:"",
    fromDate:this.date10min(new Date()),
    toDate:new Date(),
    status:[],
    orderId:"",
    size:10,
    strPage:0,
    pnr:'',
    product:'AIR',
    ticketNumber:"",
    bookedFor:"",
    bookedBy:"",
    corporate:"",
    passenger:"",
    ticketIssuance:"",
    branchId:"",
    airline:'',
    segmentType:'',
gdsPnr:''
}
peraHotel:any={
  invoiceStatus:"",
  fromDate:this.date10min(new Date()),
  toDate:new Date(),
  status:[],
  orderId:"",
  size:10,
  strPage:0,
  pnr:'',
  product:'HOTEL',
  bookingId:'',
  hotelName:'',
  branchId:"",
  hcnStatus:""
}
peraInsurance:any={
  invoiceStatus:"",
  fromDate:this.date10min(new Date()),
  toDate:new Date(),
  status:[],
  orderId:"",
  size:10,
  strPage:0,
  pnr:'',
  product:'INSURANCE',
  bookingId:'',
  hotelName:'',
  branchId:"",
  hcnStatus:""
}
airList:any=[]
totalElements:any
totalHotelElements:any
totalInsurancelElements:any

searchByOrderId(){
  
  this.AirList()

}
private _filter(value: string): string[] {
  const filterValue = value.toLowerCase();

  return this.carrierCodeList.filter((option:any) =>  option.airlineDesignatorCode.toLowerCase().includes(filterValue)||option.carrierName.toLowerCase().includes(filterValue));
}
carrierCodelist(){

  this.AirManagementService
  .carrierlist()
  .subscribe({
    next : (res:any) => {
      if(res) {
     let data=res
     this.carrierCodeList=data
     
      } else {
      
      } 
    },error : (err) => {

    }
  }
)
}
searchByHOTELOrderId(){
  this.HotelList()
}
privilegesView:any
  privilegesValue(privs:any){
   
    let privileges="";
  
  if(privs.includes('view')){
    this.privilegesView="VAMD"
  }else{
    this.privilegesView="AccessDenied"
  }
  
  }

nextPage(event:PageEvent) {
    
  this.pera['strPage'] = event.pageIndex.toString();
  this.pera['size'] = event.pageSize.toString();
 
  this.AirList()

}
@ViewChild(MatPaginator) paginator: MatPaginator | undefined;
@ViewChild(MatPaginator) Hotelpaginator: MatPaginator | undefined;
@ViewChild(MatPaginator) insurancePaginator: MatPaginator | undefined;

nextHotelPage(event:PageEvent){
  this.peraHotel['strPage'] = event.pageIndex.toString();
  this.peraHotel['size'] = event.pageSize.toString();
 
  this.HotelList()
}
airRefDate:any=new Date()
refresh(){
  this.airRefDate=new Date()

  this.moreFilters=false
  this.ToCtrl = new FormControl([]);

 this.pera={
    invoiceStatus:"",
      fromDate:this.date10min(new Date()),
      toDate:new Date(),
      status:[],
      orderId:"",
      size:10,
      strPage:0,
      pnr:'',
      product:'AIR',
      ticketNumber:"",
      bookedFor:"",
      bookedBy:"",
      corporate:"",
      passenger:"",
      ticketIssuance:"",
      branchId:"",
      airline:'',
      segmentType:'',
      gdsPnr:''

  }
  if (this.paginator) {
    // this.paginator.firstPage();
    // Alternatively, you can manually set pageIndex and pageSize
     this.paginator.pageIndex = 0;
     this.paginator.pageSize = 10;
  }
this.AirList()
}
hotelRefDate:any=new Date()

hotelRefresh(){
  this.hotelRefDate=new Date()
  this.moreFilters=false
  this.ToHotelCtrl = new FormControl([]);

  this.peraHotel={
    invoiceStatus:"",
    fromDate:this.date10min(new Date()),
    toDate:new Date(),
    status:[],
    orderId:"",
    size:10,
    strPage:0,
    pnr:'',
    product:'HOTEL',
    bookingId:'',
    hotelName:'',
    branchId:"",
    hcnStatus:"",
  }
  if (this.Hotelpaginator) {
    // this.Hotelpaginator.firstPage();
    // Alternatively, you can manually set pageIndex and pageSize
     this.Hotelpaginator.pageIndex = 0;
     this.Hotelpaginator.pageSize = 10;
  }
  this.HotelList()

}
showAirTableData:boolean=false
AirList(){
  this.showAirTableData=true
// this.pera.fromDate=this.formatDates(this.pera.fromDate)
// this.pera.toDate=this.formatDates(this.pera.toDate)
// if(this.pera.ticketNumber||this.pera.pnr||this.pera.orderId){
//   this.pera={
//     invoiceStatus:"",fromDate:'',toDate:'',status:[],orderId:this.pera.orderId,size:10,strPage:0, pnr:this.pera.pnr,product:'AIR',
//       ticketNumber:this.pera.ticketNumber, bookedFor:"",bookedBy:"",corporate:"",passenger:"",
//       ticketIssuance:"",branchId:"",airline:'',segmentType:'',gdsPnr:''
  
//   } 
// }

if(this.pera.ticketNumber||this.pera.pnr||this.pera.orderId||this.pera?.gdsPnr){
  this.pera={
    invoiceStatus:"",fromDate:'',toDate:'',status:[],orderId:this.pera.orderId,size:10,strPage:0, pnr:this.pera.pnr,product:'AIR',
      ticketNumber:this.pera.ticketNumber, bookedFor:"",bookedBy:"",corporate:"",passenger:"",
      ticketIssuance:"",branchId:"",airline:'',segmentType:'',gdsPnr:this.pera?.gdsPnr
  
  } 
}
  this.cartService
  .getAirOrders(this.pera)
  .subscribe({
    next : (res:any) => {
      this.showAirTableData=false

      if(res) {
        
     let data=res?.content
     this.airList=data

     if(data.length===0){
     }else{
      this.pera.strPage=res?.number
      this.pera.size=res?.size
    }
    this.totalElements = res["totalElements"];

   // this.Userlist=data.result.content;
   
     
     this.airList.forEach((list:any)=>{
      
    //   this.UserService.getUserbyUUid(list.createdBy)
    //   .subscribe({
    //     next : (res:any) => {
    
    //       if(res) {
    //           list.bookedBy=res?.name
            
    //       } else {
          
    //       } 
    //     },error : (err) => {
    
    //     }
    //   }
    // )
    





      list?.airItineraries.forEach((itineraries:any)=>{
        itineraries?.flightDetails?.flightDetailsList.forEach((flightDetailsList:any)=>{
          flightDetailsList.schArrivalTime=this.formatTimestamp(flightDetailsList?.schArrivalTime)
          flightDetailsList.schDepartureTime=this.formatTimestamp(flightDetailsList?.schDepartureTime)


        })
      })
     })
      } else {
      
      } 
    },error : (err) => {
      this.showAirTableData=false

    }
  }
)
}
showHotelTableData:boolean=false
hotelList:any=[]
HotelList(){

if(this.peraHotel.orderId||this.peraHotel.bookingId){


   this.peraHotel={
    invoiceStatus:"",
    fromDate:"",
    toDate:"",
    status:[],
    orderId:this.peraHotel.orderId,
    size:10,
    strPage:0,
    pnr:'',
    product:'HOTEL',
    bookingId:this.peraHotel.bookingId,
    hotelName:'',
    branchId:"",
    hcnStatus:"",
  }
}

  this.showHotelTableData=true

  this.cartService
  .getAirOrders(this.peraHotel)
  .subscribe({
    next : (res:any) => {
      this.showHotelTableData=false

      if(res) {
        
     let data=res?.content
     this.hotelList=data

     if(data.length===0){
     }else{
      this.peraHotel.strPage=res?.number
      this.peraHotel.size=res?.size
    }
    this.totalHotelElements = res["totalElements"];

  
      } else {
      
      } 
    },error : (err) => {
      this.showHotelTableData=false

    }
  }
)
}

  backClick(){
    window.location.href='/app/flight'

  }
  formatDate(val: Date) {
    let convertedValue:any = ""
    if(val){
    let datepipe = new DatePipe("en");
    //return datepipe.transform(val, "dd-MM-yyyy hh:mm:ss");
    convertedValue =  datepipe.transform(val, "dd-MM-yyyy HH:mm:ss");
    // convertedValue =  datepipe.transform(val, "dd-MM-yyyy hh:mm:ssa");

    }
    return convertedValue;
  }
  
  formatSummaryDate(val: any) {
    const timestamp = val;
    const date = new Date(timestamp);
  

    const options: Intl.DateTimeFormatOptions = { day: '2-digit', month: 'short' };
    const formattedDate = date.toLocaleDateString('en-GB', options).replace(',', '');
    

    // console.log(formattedDate)
   return formattedDate.replace(' ','-'); // Output: "17-Jun"
    
  }
  

  
  formatTimestamp(timestamp: any): any {
    const dateObj = new Date(timestamp);
    let datepipe = new DatePipe("en");

    return datepipe.transform(dateObj, 'yyyy-MM-ddTHH:mm:ss.SSSZ');
  }
  bookingStatus(item:any){
    this.pera.status=item
  this.AirList()

  }
  
  onModifyClick(data:any){
    // let url= "/app/modify-cart?id="+this.SettingsService.transform(item)
    // window.open(url);
    this.dataService.deliverMsg(data)
    let url="/app/modify-cart?id="+data.uuid
    window.open(url)
    // this.showStatus=false
    // this.modifyCart=true
    // this.screenChange=true

  }
  onViewHClick(data:any){
    let url="/app/view-cart?id="+data.uuid
    window.open(url)
  }
  onModifyHClick(data:any){
    // let url= "/app/modify-cart?id="+this.SettingsService.transform(item)
    // window.open(url);
    // this.dataService.deliverMsg(data)
    let url="/app/modifyCart?id="+data.uuid
    window.open(url)
    // this.showStatus=false
    // this.modifyCart=true
    // this.screenChange=true

  }
  onCartStatusClick(data:any){
    this.dataService.deliverMsg(data)
    this.modifyCart=false
     this.showStatus=true
     this.screenChange=true
  }

  screenChange:boolean=false
  showStatus:boolean=false
  modifyCart:boolean=false

  getUserByUUid(id:any){

   
  
  }
  totalService(bookingTime: any, gents: any) {
    let bookingTs: any = new Date(bookingTime);
    let creationTs: any = new Date(gents);
    let duration: any = (bookingTs - creationTs) / 1000; // Convert milliseconds to seconds
    // console.log(duration);

    return duration.toFixed(0)+' Seconds'
  }
  supplierService(bookingTime: any, bookingRequestTs: any) {
    // console.log(bookingTime)
    // console.log(bookingRequestTs)

    let bookingTs: any = new Date(bookingTime);
    let BookingRequestTs: any = new Date(bookingRequestTs);
    let duration: any = (bookingTs - BookingRequestTs) / 1000; // Convert milliseconds to seconds
    // console.log(duration);

    return duration.toFixed(0)+' Seconds'
  }
  ServiceUser(bookingRequestTs: any, gents: any) {
    

    let BookingRequestTs: any = new Date(bookingRequestTs);
    let creationTs: any = new Date(gents);
    let duration: any = (BookingRequestTs - creationTs) / 1000; // Convert milliseconds to seconds
    // console.log(duration);

    return duration.toFixed(0)+' Seconds'
  }
searchby:any='CARTID'
  searchBy(item:any){
    this.pera.orderId=''
    this.pera.pnr=''
this.searchByOrderId()
    this.searchby=item

    
  }

  generatePDF(item:any,invoiceLabel:any){
    this.FlightService
    .downloadCartPdf(item.uuid,invoiceLabel)
    .subscribe({
      next : (res:any) => {
        if(res) {
         let data:any
         data=res  
        //  console.log(data)
  
       
  
        var fileName = "Ticket_"+item?.pnr.replace(',','_') + ".pdf";
  var blob = data; // Assuming 'data' contains your PDF data
  var file = new Blob([blob], { type: 'application/pdf' });
  
  // Create a download link
  var a = document.createElement("a");
  a.href = window.URL.createObjectURL(file);
  a.download = fileName;
  
  // Append the link to the document
  document.body.appendChild(a);
  
  // Trigger a click on the link to start the download
  a.click();
  
  // Remove the link from the document after the download is initiated
  document.body.removeChild(a);
        } else {    
        } 
      },error : (err) => {
  
  
      }
    }
  )
  
  }

  showFormate:any='12'
  showTime:boolean=true
  dateCartFormate(date:any){

    const parsedDate = new Date(date);
    const datePipe = new DatePipe('en-IN');
    date = datePipe.transform(parsedDate, "yyyy-MM-dd'T'HH:mm:ss.SSS"+'+0530');
    // date = datePipe.transform(parsedDate, 'EEE dd MMM yyyy');
  return date
  
  }
  formatDates(val: Date) {
    let convertedValue:any = ""
    if(val){
    let datepipe = new DatePipe("en");
    //return datepipe.transform(val, "dd-MM-yyyy hh:mm:ss");
    convertedValue =  datepipe.transform(val, "YYYY-MM-ddTHH:mm:ss.SSS+0530");
    }
    if(val===null){
     
      //return datepipe.transform(val, "dd-MM-yyyy hh:mm:ss");"
      convertedValue =  "-";
      }
    return convertedValue;
  }


  showSpinners = true;        // Show spinners for time input
  showSeconds = true;         // Allow seconds input
  stepHour = 1;               // Hour step
  stepMinute = 1;             // Minute step
  stepSecond = 1;             // Second step
  touchUi = false;            // Show in touch UI mode
  color: 'primary' | 'accent' | 'warn' = 'primary'; // Date picker color
  enableMeridian = false;      // 12-hour format (AM/PM)
  disableMinute = false;      // Enable/disable minute input
  hideTime = false;           // Hide time portion of the picker
  disabled = false;  
  onClick(item:any){
    this.pera.invoiceStatus=item
    this.searchByOrderId()
  }
  onHotleClick(item:any){
    this.peraHotel.invoiceStatus=item
    this.searchByHOTELOrderId()
  }

  // separatorKeysCodesTo: number[] = [ENTER, COMMA];

  whereTo:any=[];
  bookedByList:any=[];

  ToCtrl = new FormControl([]);
  ToHotelCtrl=new FormControl([]);
  bookedBYCtrl = new FormControl([]);

  filteredTo: Observable<any[]>;
  filteredHotelTo: Observable<any[]>;

  filteredBookedBY:Observable<any[]>;
  wherecity: any[] = [''];
  addTo(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();

    // Add our fruit
    if (value) {
      this.wherecity.push(value);
    }

    // Clear the input value
    event.chipInput!.clear();

    this.ToCtrl.setValue(null);
  }

  selectedTo(event:any): void {
   
    //  console.log(event)
    //this.emulateName=event.option.value.name
     this.pera.corporate=event?.userUid||""
     this.searchByOrderId()

    
  }
  selectedHotelTo(event:any): void {
   
    //  console.log(event)
    //this.emulateName=event.option.value.name
     this.peraHotel.corporate=event?.userUid||""
     this.searchByHOTELOrderId()

    
  }
  selectedBookedBY(event:any): void {
   
    //  console.log(event)
    //this.emulateName=event.option.value.name
     this.pera.bookedBy=event?.userUid||""
     this.searchByOrderId()

    
  }

  generateHotelPDF(element:any,invoiceLable:any){
    this.cartService
    .downloadCartPdf(element?.uuid,invoiceLable)
    .subscribe({
      next : (res:any) => {
        if(res) {
         let data:any
         data=res  
        //  console.log(data)
  
       
  
        var fileName = "Voucher_"+element?.uuid.replace(',','_') + ".pdf";
  var blob = data; // Assuming 'data' contains your PDF data
  var file = new Blob([blob], { type: 'application/pdf' });
  
  // Create a download link
  var a = document.createElement("a");
  a.href = window.URL.createObjectURL(file);
  a.download = fileName;
  
  // Append the link to the document
  document.body.appendChild(a);
  
  // Trigger a click on the link to start the download
  a.click();
  
  // Remove the link from the document after the download is initiated
  document.body.removeChild(a);
        } else {    
        } 
      },error : (err) => {
  
  
      }
    }
  )
  
  }
 
branchData:any=[]
branchList(){

  this.AirManagementService
  .branchlist()
  .subscribe({
    next : (res:any) => {
      if(res) {
     this.branchData=res
   
      } else {
      
      } 
    },error : (err) => {

    }
  }
)
}



exportDatas(){

  let  curdatestring:Date=new Date()
 // let  exportData:any=JSON.parse(this.userExcel)
 let request:any=[]

for(let element of this.airList){
let Itinerari:any=[]
  for(let Itineraries of element.airItineraries){
    Itinerari.push(Itineraries?.airline+'-'+Itineraries?.flightNumber+'|'+Itineraries?.sector+'|'+this.formatSummaryDate(Itineraries?.flightDetails?.flightDetailsList[0]?.schDepartureTime))
  }
  let data:any={
    "Generation_Time":this.formatDate(element?.creationTs),
    "First_Departure":this.formatDate(element?.airItineraries[0]?.flightDetails?.flightDetailsList[0]?.schDepartureTime),
    "CartId":element?.uuid,
    "BookedBy":element?.createdBy?.split('-')[1],
    "Corporate/Agent":element?.corporate?.split('-')[1]||'-',
    "Invoice_Status":element?.invoiceStatus==='N'?('NEW'):element?.invoiceStatus==='P'?('PENDING'):element?.invoiceStatus==='S'?('SUCCESS'):'',
    "Summary":Itinerari.join(' - ' ),
    "Service_Time":element?.bookingTs?(this.totalService(element?.bookingTs,element?.creationTs)):'-',
    "Booking_Status":this.getStatusDescription(element?.status),
    "Payment_Status":element?.paymentStatus==='P'?('PAID'):element?.paymentStatus==='F'?('FAILED'):element?.paymentStatus==='I'?('INITIATED'):element?.paymentStatus==='A'?('ABORTED'):element?.paymentStatus==='U'?('UNPAID'):'',
    "invoiceData":this.invoiceJsonData(element?.invoiceData)
  }
request.push(data)
}

 const dataWithUppercaseHeaders = request.map((item: any) => {
   const transformedItem: any = {};
   for (const key in item) {
     if (item.hasOwnProperty(key)) {
       transformedItem[key.toUpperCase()] = item[key];
     }
   }
   return transformedItem;
 });
 
 // Convert the modified data to a worksheet
 const worksheet = XLSX.utils.json_to_sheet(dataWithUppercaseHeaders);
 const workbook = XLSX.utils.book_new();
 XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
 
 // Write the workbook to a file
 XLSX.writeFile(workbook, "Air_" + curdatestring + ".xlsx");
  }

    Status:any ={
    "N" : "NEW",
    "B" : "BOOKED",
    "Z" :"PARTIALLY BOOKED",
    "P" : "FAILED ",
    "S" :"FAILED",
    "R" :"PAYMENT FAILED",
    "A" :"ABORTED",
    "TC" : "TO CANCEL",
    "C" :"CANCELLED",
    "T":"PENDING TICKET",
    "X":"FAILED",
    "F":"FAILED",

  }
   hotelStatus:any ={
    "N" : "NEW",
    "PG" : "BOOKED",
    "HP" :"PARTIALLY BOOKED",
    "OK" : "FAILED ",
    "CO" :"FAILED",
    "PB" :"PAYMENT FAILED",
    "FD" :"ABORTED",
    "CN" : "TO CANCEL",
    "CR" :"CANCELLED",
    "PC" :"CANCELLED"

  }
  getStatusDescription(status: any) {
   
    return this.Status[status]; // Get the description of the status
  }
   getStatusHotelDescription(status: any) {
    
    return this.hotelStatus[status]; // Get the description of the status
  }
  invoiceJsonData(result:any){
    const replaceNullWithUndefined = (obj: any): any => {
      if (obj === null) {
        return undefined;
      }
      if (Array.isArray(obj)) {
        return obj.map(replaceNullWithUndefined);
      }
      if (typeof obj === 'object' && obj !== null) {
        return Object.fromEntries(
          Object.entries(obj).map(([key, value]) => [key, replaceNullWithUndefined(value)])
        );
      }
      return obj;
  }
  const modifiedResult = replaceNullWithUndefined(result);

  // Convert the modified result to a JSON string with 4-space indentation
  return JSON.stringify(modifiedResult, (key, value) => value === undefined ? undefined : value, 4);
}


exportHotelDatas(){

  let  curdatestring:Date=new Date()
 // let  exportData:any=JSON.parse(this.userExcel)
 let request:any=[]

for(let element of this.hotelList){
// let Itinerari:any=[]
//   for(let Itineraries of element.airItineraries){
//     Itinerari.push(Itineraries?.airline+'-'+Itineraries?.flightNumber+'|'+Itineraries?.sector+'|'+this.formatSummaryDate(Itineraries?.flightDetails?.flightDetailsList[0]?.schDepartureTime))
//   }
  let data:any={
    "Generation_Time":this.formatDate(element?.creationTs),
    "Check-In":element?.hotelBooking?.hotelRequest?.checkInDate,
    "CartId":element?.uuid,
    "BookedBy":element?.createdBy?.split('-')[1],
    "Corporate/Agent":element?.corporate?.split('-')[1]||'-',
    "Invoice_Status":element?.invoiceStatus==='N'?('NEW'):element?.invoiceStatus==='P'?('PENDING'):element?.invoiceStatus==='S'?('SUCCESS'):'',
    "Booking_Id":element?.bookingId||'-',
    "Service_Time":element?.bookingTs?(this.totalService(element?.bookingTs,element?.creationTs)):'-',
    "Booking_Status":this.getStatusHotelDescription(element?.status),
    "Payment_Status":element?.paymentStatus==='P'?('PAID'):element?.paymentStatus==='F'?('FAILED'):element?.paymentStatus==='I'?('INITIATED'):element?.paymentStatus==='A'?('ABORTED'):element?.paymentStatus==='U'?('UNPAID'):'',
    // "invoiceData":this.invoiceJsonData(element?.invoiceData)
  }
request.push(data)
}

 const dataWithUppercaseHeaders = request.map((item: any) => {
   const transformedItem: any = {};
   for (const key in item) {
     if (item.hasOwnProperty(key)) {
       transformedItem[key.toUpperCase()] = item[key];
     }
   }
   return transformedItem;
 });
 
 // Convert the modified data to a worksheet
 const worksheet = XLSX.utils.json_to_sheet(dataWithUppercaseHeaders);
 const workbook = XLSX.utils.book_new();
 XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
 
 // Write the workbook to a file
 XLSX.writeFile(workbook, "Hotel_" + curdatestring + ".xlsx");
  }




  exportData() {

    let  curdatestring:Date=new Date()
    // let  exportData:any=JSON.parse(this.userExcel)
    let mappedData: any = []
   
   for(let element of this.airList){
   let Itinerari:any=[]
     for(let Itineraries of element.airItineraries){
       Itinerari.push(Itineraries?.airline+'-'+Itineraries?.flightNumber+'|'+Itineraries?.sector+'|'+this.formatSummaryDate(Itineraries?.flightDetails?.flightDetailsList[0]?.schDepartureTime))
     }
     let data:any={
       "Generation_Time":this.formatDate(element?.creationTs),
       "First_Departure":this.formatDate(element?.airItineraries[0]?.flightDetails?.flightDetailsList[0]?.schDepartureTime),
       "CartId":element?.uuid,
       "BookedBy":element?.createdBy?.split('-')[1],
       "Corporate/Agent":element?.corporate?.split('-')[1]||'-',
       "Invoice_Status":element?.invoiceStatus==='N'?('NEW'):element?.invoiceStatus==='P'?('PENDING'):element?.invoiceStatus==='S'?('SUCCESS'):'',
       "Summary":Itinerari.join(' - ' ),
       "Service_Time":element?.bookingTs?(this.totalService(element?.bookingTs,element?.creationTs)):'-',
       "Booking_Status":this.getStatusDescription(element?.status),
       "Payment_Status":element?.paymentStatus==='P'?('PAID'):element?.paymentStatus==='F'?('FAILED'):element?.paymentStatus==='I'?('INITIATED'):element?.paymentStatus==='A'?('ABORTED'):element?.paymentStatus==='U'?('UNPAID'):'',
       "invoiceData":this.invoiceJsonData(element?.invoiceData)
     }
     mappedData.push(data)
   }
   
  
   
    console.log(mappedData)
  
    // Create a new workbook and add a worksheet
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Flight Data');
  
    // Apply header styles
    this.applyHeaderStyles(worksheet,mappedData);
  
    // Add the mapped data to the worksheet
    mappedData.forEach((item: any) => {
      worksheet.addRow(item);
    });
  
    // Save workbook to a file
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = "Air_" + this.formatDate(curdatestring) + ".xlsx";
      link.click();
    });
  }
 
  applyHeaderStyles(worksheet: ExcelJS.Worksheet, data: any[]): void {
    if (!data || data.length === 0) {
      return;
    }
  
    // Get keys from the first object in the data array
    // const headers = Object.keys(data[0]);
  
    // // Set worksheet columns dynamically with same width
    // worksheet.columns = headers.map(key => ({
    //   header: key,
    //   key: key,
    //   width: 20 // You can make this dynamic too if needed
    // }));
    // if (!data || data.length === 0) {
    //   return;
    // }
    
  
    // Get dynamic headers from data keys
  
    // Set columns with headers and default width
    // worksheet.columns = headers.map(key => ({
    //   header: key.toUpperCase(),
    //   key: key,
    //   width: 20
    // }));

    worksheet.columns = [
      { header: 'Generation_Time', key: 'Generation_Time', width: 20 },
      { header: 'First_Departure', key: 'First_Departure', width: 35 },
      { header: 'Cart Id', key: 'CartId', width: 20 },
      { header: 'Booked By', key: 'BookedBy', width: 20 },
      { header: 'Corporate/Agent', key: 'Corporate/Agent', width: 35 },
      { header: 'Invoice_Status', key: 'Invoice_Status', width: 35 },
      { header: 'Summary', key: 'Summary', width: 20 },
      { header: 'Service_Time', key: 'Service_Time', width: 20 },
      { header: 'Booking_Status', key: 'Booking_Status', width: 20 },
      { header: 'Payment_Status', key: 'Payment_Status', width: 35 },
      // { header: 'InvoiceData', key: 'invoiceData', width: 35 },

    ];
    // worksheet.columns = headers.map(key => ({
    //   header: key.toUpperCase(),
    //   key: key,
    //   width: 20
    // }));
  
  
    
    //  Map headers to worksheet.columns and apply uniform width
    // worksheet.columns = headers.map(header => ({
    //   header,
    //   key: header,
    //   width: 25 // set your desired width here
    // }));
  
    // Apply styles to the header row (row 1)
    const headerRow = worksheet.getRow(1);
    headerRow.eachCell((cell) => {
      cell.font = { bold: true, color: { argb: 'FFFFFFFF' } }; // white text
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '4472C4' } // dark blue background (you can change it)
      };
      cell.alignment = { vertical: 'middle', horizontal: 'center' };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' }
      };
    });
  
    // Optional: Adjust row height
    headerRow.height = 25;
  
    headerRow.commit(); // Commit changes to the row
    
  
  }





  exportHotelData() {

    let  curdatestring:Date=new Date()
    // let  exportData:any=JSON.parse(this.userExcel)
    let mappedData: any = []
   
    for(let element of this.hotelList){
      // let Itinerari:any=[]
      //   for(let Itineraries of element.airItineraries){
      //     Itinerari.push(Itineraries?.airline+'-'+Itineraries?.flightNumber+'|'+Itineraries?.sector+'|'+this.formatSummaryDate(Itineraries?.flightDetails?.flightDetailsList[0]?.schDepartureTime))
      //   }
        let data:any={
          "Generation_Time":this.formatDate(element?.creationTs),
          "Check-In":element?.hotelBooking?.hotelRequest?.checkInDate,
          "CartId":element?.uuid,
          "BookedBy":element?.createdBy?.split('-')[1],
          "Corporate/Agent":element?.corporate?.split('-')[1]||'-',
          "Invoice_Status":element?.invoiceStatus==='N'?('NEW'):element?.invoiceStatus==='P'?('PENDING'):element?.invoiceStatus==='S'?('SUCCESS'):'',
          "Booking_Id":element?.bookingId||'-',
          "Service_Time":element?.bookingTs?(this.totalService(element?.bookingTs,element?.creationTs)):'-',
          "Booking_Status":this.getStatusHotelDescription(element?.status),
          "Payment_Status":element?.paymentStatus==='P'?('PAID'):element?.paymentStatus==='F'?('FAILED'):element?.paymentStatus==='I'?('INITIATED'):element?.paymentStatus==='A'?('ABORTED'):element?.paymentStatus==='U'?('UNPAID'):'',
          // "invoiceData":this.invoiceJsonData(element?.invoiceData)
        }
        mappedData.push(data)
      }
   
  
   
    console.log(mappedData)
  
    // Create a new workbook and add a worksheet
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('HOTEL Data');
  
    // Apply header styles
    this.applyHeaderHotelStyles(worksheet,mappedData);
  
    // Add the mapped data to the worksheet
    mappedData.forEach((item: any) => {
      worksheet.addRow(item);
    });
  
    // Save workbook to a file
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download =  "Hotel_" + this.formatDate(curdatestring) + ".xlsx";
      link.click();
    });
    
  }
  applyHeaderHotelStyles(worksheet: ExcelJS.Worksheet, data: any[]): void {
    if (!data || data.length === 0) {
      return;
    }
  
    

    worksheet.columns = [
      { header: 'Generation_Time', key: 'Generation_Time', width: 20 },
      { header: 'Check-In', key: 'Check-In', width: 35 },
      { header: 'Cart Id', key: 'CartId', width: 20 },
      { header: 'Booked By', key: 'BookedBy', width: 20 },
      { header: 'Corporate/Agent', key: 'Corporate/Agent', width: 35 },
      { header: 'Booking_Id', key: 'Booking_Id', width: 35 },
      { header: 'Summary', key: 'Summary', width: 20 },
      { header: 'Service_Time', key: 'Service_Time', width: 20 },
      { header: 'Booking_Status', key: 'Booking_Status', width: 20 },
      { header: 'Payment_Status', key: 'Payment_Status', width: 35 },
      // { header: 'InvoiceData', key: 'invoiceData', width: 35 },

    ];
   
    const headerRow = worksheet.getRow(1);
    headerRow.eachCell((cell) => {
      cell.font = { bold: true, color: { argb: 'FFFFFFFF' } }; // white text
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '4472C4' } // dark blue background (you can change it)
      };
      cell.alignment = { vertical: 'middle', horizontal: 'center' };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' }
      };
    });
  
    // Optional: Adjust row height
    headerRow.height = 25;
  
    headerRow.commit(); // Commit changes to the row
    
  
  }


  onTabChange(event: MatTabChangeEvent): void {
    if (event.tab.textLabel === 'Air') {
      this.AirList()
    }else if(event.tab.textLabel === 'Hotel'){
      this.HotelList()

    }
    else if(event.tab.textLabel === 'Insurance'){
      this.InsuranceList()
    }
  }


  showInsuranceTableData:boolean=false
  insuranceList:any=[]
  insuranceRefDate:any=new Date()

  insuranceRefresh(){
  this.insuranceRefDate=new Date()
    this.peraHotel={
      invoiceStatus:"",
      fromDate:this.date10min(new Date()),
      toDate:new Date(),
      status:[],
      orderId:"",
      size:10,
      strPage:0,
      pnr:'',
      product:'INSURANCE',
      bookingId:'',
      hotelName:'',
      branchId:"",
      hcnStatus:"",
    }
    if (this.insurancePaginator) {
      // Alternatively, you can manually set pageIndex and pageSize
       this.insurancePaginator.pageIndex = 0;
       this.insurancePaginator.pageSize = 10;
    }
    this.InsuranceList()
  
  }
  nextInsurancePage(event:PageEvent){
    this.peraInsurance['strPage'] = event.pageIndex.toString();
    this.peraInsurance['size'] = event.pageSize.toString();
   
    this.InsuranceList()
  }

  onInsuranceClick(item:any){
    this.peraHotel.invoiceStatus=item
    this.InsuranceList()
  }

InsuranceList(){
  this.showInsuranceTableData=true

  this.cartService
  .getAirOrders(this.peraInsurance)
  .subscribe({
    next : (res:any) => {
      this.showInsuranceTableData=false

      if(res) {
        
     let data=res?.content
     this.insuranceList=data

     if(data.length===0){
     }else{
      this.peraInsurance.strPage=res?.number
      this.peraInsurance.size=res?.size
    }
    this.totalInsurancelElements = res["totalElements"];

  
      } else {
      
      } 
    },error : (err) => {
      this.showInsuranceTableData=false

    }
  }
)
}


onViewIClick(data:any){
  let url="/app/view-Insurance-Cart?id="+data.uuid
  window.open(url)
}
onModifyIClick(data:any){
  // let url= "/app/modify-cart?id="+this.SettingsService.transform(item)
  // window.open(url);
  // this.dataService.deliverMsg(data)
  let url="/app/modify-Insurance-Cart?id="+data.uuid
  window.open(url)
  // this.showStatus=false
  // this.modifyCart=true
  // this.screenChange=true
}
}

